<script setup lang="ts">
import { TrendingUp, TrendingDown, Minus } from 'lucide-vue-next'
import { formatPriceChange, priceChangeClass } from '@/lib/money'

/**
 * A period-over-period price move: arrow, signed value, and the colour that reads
 * as good or bad on this side.
 *
 * A percentage is the one price figure that carries no currency, so this is the one
 * cell both market cards can share — and they were carrying four copies of it plus
 * two of the colour rule between them.
 *
 * Distinct from `PercentageChange.vue`, which is the uncoloured single-line form the
 * prices grid uses.
 */
defineProps<{
    value: number | null | undefined
}>()
</script>

<template>
    <span
        v-if="formatPriceChange(value)"
        class="inline-flex items-center gap-0.5 tabular-nums"
        :class="priceChangeClass(value)"
    >
        <TrendingUp v-if="value! > 0" class="size-3" />
        <TrendingDown v-else-if="value! < 0" class="size-3" />
        <Minus v-else class="size-3" />
        {{ formatPriceChange(value) }}
    </span>
    <span v-else class="text-muted-foreground">—</span>
</template>
